<template>
  <div>
    <div class="mb-12 page-title">พิจารณาคำร้องขอใช้พื้นที่</div>
    <div class="list-layout">
      <div v-for="(item, i) in evaluateLists" :key="i">
  <RowCard>
    <div :style="{ color: getColorVariable(), width: headers[0].width }">
      {{ item?.No }}
    </div>
    <div :style="{ width: headers[1].width }">
      <!-- {{ item?.name  }} -->
        อุทยานวิทยาศาสตร์
    </div>
    <div :style="{ width: headers[2].width }">
      {{ item?.region }}
    </div>
    <div :style="{ width: headers[3].width }">
      ครั้งที่ {{ item?.running_number }}
        <!-- {{ item?.time }} -->
    </div>
    <div class="d-flex align-center justify-center " :style="{ width: headers[4].width }">
      <Button v-if="item?.areaGroupExpert?.status !== 'Submitted'"
        @onClick="consider(item)"
        :disabled="!checkStatus(item)"
        :theme="checkStatus(item) ? 1 : 2"
        minWidth="124px"
      >
          <Iconify
            icon="material-symbols-light:mail-rounded"
            size="18px"
            class="mr-2"
            color="#ffffff"
          ></Iconify>
        <span v-if="checkStatus(item)">ส่งผลพิจารณา</span>
        <span  v-else>พิจารณา</span>
      </Button>
      <span :style="{  color: 'var(--theme-color-three)' }" v-else>พิจารณาเสร็จสิ้น</span>
    </div>
    <v-btn
      icon
      :class="{ rotate180: isExpanded[i] }"
      @click="() => seeDetail(i)"
    >
      <Iconify
        icon="material-symbols:keyboard-arrow-down"
        size="32px"
        :color="getColorVariable()"
      ></Iconify>
    </v-btn>
  </RowCard>
  <div class="expand-layout px-5" :class="`expand-${i}`">
    <div class="expand-content d-flex flex-column gap-12">
      <div>
        รายการโครงการย่อย
      </div>
      <div class="d-flex text-left items-center  justify-space-between table-head">
              <div
                v-for="(item, i) in subHeaders"
                :key="i"
                :style="{ width: item.width, color: '#B1B1B1'}"
              >
                {{ item.name }}
              </div>
            </div>
            <div  v-if='item?.area_forms.length > 0'>
              <div
                v-for="(area, i) in item?.area_forms" 
                :key="area.id || i" 
                class="d-flex px-9 gap-8 text-left items-center justify-space-between">
              <div  div :style="{ width: subHeaders[0]?.width }">
                  <v-btn v-if="area?.status"
                    small
                    icon
                    class="edit-icon-class"
                    @click="onEdit(area.id , area?.evaluate_forms?.status, area?.evaluate_forms?.id)"
                  >
                    <Iconify v-if="area?.evaluate_forms?.status === 'Submitted'" icon="material-symbols:visibility" color="orange" size="18px"></Iconify>
                    <Iconify v-else icon="material-symbols:edit" color="orange" size="18px"></Iconify>
                  </v-btn>
                <v-btn 
                v-else
                small  
                class="edit-icon-class"
                icon @click="onPreview()">
                 
                    <Iconify icon="carbon:view-filled" color="orange" size="18px"></Iconify>
                  </v-btn>
                </div>
                <div :style="{ width: subHeaders[1].width }">
                  {{ area?.area_form_2?.company_name_th }}
                </div>
                <div :style="{ width: subHeaders[2].width }">
                  {{ area?.created_by }}
                  
                </div>
                <div :style="{ width: subHeaders[3].width ,color: area?.evaluate_forms === null ? '' : getColorStatus(area?.evaluate_forms?.status) }">
                  {{ area?.evaluate_forms === null ? 'รอพิจารณา' : getStatusName(area?.evaluate_forms?.status) }}
                </div>
              </div>
            </div>
              <div v-else class='flex text-center'>
                ไม่มีข้อมูล
              </div>
    </div>
  </div>
</div>

  </div>
  <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getLists"
    ></v-pagination>
  </div>
</template>

<script>
import RowCard from "@/components/RowCard";
import { toDateFormat, formatNumber } from "@/plugins/global-funcs";
import Button from "@/components/input/Button";
import { color } from "highcharts";

export default {
  name: "EvaluateRequest",
  components: {
    RowCard,
    Button
  },
  data() {
    return {
      toDateFormat,
      formatNumber,
      redText: false,
      isExpanded: [],
    
      headers: [
        {
          name: "",
          width: "8%",
        },

        {
          name: "",
          width: "30%",
        },
        {
          name: "",
          width: "12%",
        },
        {
          name: "",
          width: "15%",
        },
        {
          name: "",
          width: "15%",
        },
        {
          name: "",
          width: "20%",
        },
       
      ],
      subHeaders: [
        {
          name: "ลำดับ",
          width: "10%",
        },

        {
          name: "บริษัทผู้ประกอบการ",
          width: "60%",
        },
        {
          name: "ผู้นำเข้าข้อมูล",
          width: "15%",
        },
        {
          name: "สถานะ",
          width: "15%",
        },
      ],
      evaluateLists: [],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
      
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    seeDetail(index) {
      let growDiv = document.querySelector(`.expand-${index}`);
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.$set(this.isExpanded, index, false);
      } else {
        let wrapper = growDiv.querySelector(".expand-content");
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.$set(this.isExpanded, index, true);
      }
    },
    getColorVariable() {
      return 'var(--theme-color-one)';
    },
    getColorStatus(status) {
      if(status == 'In Review' ){
        return 'var(--theme-color-five)';
      }else if(status == 'Draft' ) {
        return 'var(--theme-color-one)';
      }else if(status == 'Submitted' ) {
        return 'var(--theme-color-three)';
      }
    },
    getStatusName(status) {
      if(status == 'Submitted' ){
        return 'บันทึกคะแนนแล้ว';
      }else if(status == 'Draft' ) {
        return 'บันทึกฉบับร่าง';
      }
    },
    checkStatus(data) {
      if (data?.area_forms.length === 0) return false
      console.log('checkStatus data: ', data);
      const status = data?.area_forms.every(
        (item) => item?.evaluate_forms?.status === 'Submitted'
      );
      return status
    },
    async getLists(page) {
      let payload = {
        page: page ?? this.paginate.current_page,
      };
      let res = await this.$apiFire("Consider/getEvaluateAreaListExpert",payload);
      if (res) {
      console.log("res: ",res);
        this.evaluateLists = res?.data.map((item, index) => {
          return {
            ...item,
            No: (res.current_page - 1) * res.per_page + index + 1,
          };
        });
        this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
      }
    },
    async consider(data) {
      const status = this.checkStatus(data)
      console.log('data.id',data.id);
      
      if (status === false) return
      else{
        let res = await this.$apiFire("Consider/considerEvaluateForm",data.id);
      if (res) {
        this.getLists();
      }
      }
    },
    onEdit(id, status ,evaID) {
    if(status == 'Submitted') {
      this.$router.push({ name: "EvaluateView", params: { 
        id: evaID,
       },
       query: {
         formType: 'area-form'
       }
    }
      
      ,);
    }else {
      this.$router.push({ name: "EvaluateForm", params: { 
        id: id,
        formType: 'area-form'
       } });
    } 
    },
    onPreview() {
      console.log('onPreview');
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 8px 33px 8px 36px;
  margin-bottom: 12px;
  border-bottom: solid 1px var(--theme-color-nine);
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
.edit-icon-class{
  translate: 0 -5px;
}
</style>
